export default async ({ store, redirect }) => {
  // If the user is authenticated redirect to home page
  const { currentUser } = store.state.auth;
  if (!currentUser.name) {
    return redirect('/account/register');
  }
};
